import { User } from '@property.com.au/argonaut';
import { DataGetter, trackView } from '@rea-argonaut/analytics';
import { getCampaignData, getPageData } from '@realestate.com.au/iglu-data';
import { deepOmitTypeName } from './deepOmitTypeName';
import { objectRemoveEmptyDeep } from './objectRemoveEmptyDeep';
import { getPcaUserData } from './getPcaUserData';

type SchoolPageTrackingData = {
  pageData: {
    pageType: string;
    siteSection: string;
    site: string;
    siteSubSection: string;
  };
  useUserContext: boolean;
  schoolContext: {
    schema: string;
    data: {
      school_name: string;
      school_sector: string;
    };
  } | null;
};

type SchoolPageContext = {
  school?: SchoolPageTrackingData['schoolContext'];
};

export const trackSchoolPageView = ({
  tracking,
  user,
}: {
  tracking: SchoolPageTrackingData;
  user: User;
}) => {
  const { pageData, useUserContext, schoolContext } = tracking;
  /*
   * Object key "school" maps to:
   * https://git.realestate.com.au/cia/iglu-server/blob/master/schemas/au.com.property/pca_school
   */
  const contexts: SchoolPageContext = {
    school: schoolContext ?? undefined,
  };

  const trackingData: DataGetter[] = [
    getPageData(deepOmitTypeName(pageData)),
    getCampaignData(),
    () => objectRemoveEmptyDeep(deepOmitTypeName(contexts)),
  ];

  if (useUserContext) {
    trackingData.push(getPcaUserData(user));
  }

  trackView(trackingData);
};
